<template>
  <div class="item" :class="{ active: isActive }" @click="goToPage">
    <IconFont :name="itemData.icon" size="18" />
    <span>{{ itemData.title }}</span>
  </div>
</template>

<script>
import IconFont from "../IconFont/index.vue";
export default {
  components: {
    IconFont,
  },
  props: {
    itemData: {
      type: Object,
      default: () => ({
        name: "",
        title: "",
        icon: "",
      }),
    },
    pathPrefix: {
      type: String,
      default: "accountCenter",
    },
    before: {
      type: Function,
      default: () => Promise.resolve(),
    },
  },
  computed: {
    isActive() {
      return this.$route.path.includes(this.itemData.name);
    },
  },
  methods: {
    async goToPage() {
      const targetPath = `/${this.pathPrefix}/${this.itemData.name}`;
      await this.before(this.itemData);
      if (this.$route.path !== targetPath) {
        this.$router.replace(targetPath);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.item {
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 40px;
  border-radius: 4px;
  gap: 6px;
  cursor: pointer;
  color: #262626;
  transition: background 0.3s, color 0.3s;
  margin-bottom: 8px;
  font-size: 14px;
  &:hover {
    color: #0062ff;
  }
}

.active {
  background: #fff !important;
  color: #0062ff;

  i {
    color: #0062ff;
  }
}
</style>
